import React from 'react';
export const PageError = ({ title, error }) => {
    return (React.createElement("div", { className: "flex flex-col w-full min-h-screen" },
        React.createElement("div", { className: "flex-1 flex items-center justify-center bg-gray-50" },
            React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-lg p-6 max-w-md" },
                React.createElement("h2", { className: "text-lg font-semibold text-red-800 mb-2" }, title),
                React.createElement("p", { className: "text-red-600" }, error)))));
};
